import { BoxProps } from 'UIKit/Box/types'
import OpenEffect from 'UIKit/OpenEffect'
import { useIsomorphicEffect } from 'hooks/useIsomorphicEffect'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'state'
import { useAppStatus } from 'state/app/hooks'
import { useSystemData } from 'state/system/hooks'
import styled from 'styled-components'
import { MaintenanceNoti } from './MaintenanceNoti'

enum OpenView {
  Maintenance = 'maintenance',
  Welcomepack = 'welcomepack',
}

const NotificationBar: React.FC<BoxProps> = ({ ...props }) => {
  const systemInfo = useSystemData()
  const { isFinishFetch } = useAppStatus()

  const [openView, setOpenView] = useState<OpenView | null>(null)

  const serverTimeMargin = useSelector((state: AppState) => state.app.serverTimeMargin)

  useIsomorphicEffect(() => {
    if (!isFinishFetch) return
    const root = document.querySelector(':root') as any
    if (openView) {
      root.style.setProperty('--notification-bar-height', '40px')
    }
    return () => root.style.setProperty('--notification-bar-height', '0px')
  }, [openView, isFinishFetch])

  useEffect(() => {
    if (!systemInfo.isEnableMaintenanceMode || (!serverTimeMargin && serverTimeMargin !== 0)) return

    const shutdownTime = systemInfo.serviceShutdownAt
    const rightJustNow = new Date().getTime() + serverTimeMargin
    if (shutdownTime - rightJustNow > 1800000) {
      const timeout = setTimeout(() => {
        setOpenView(OpenView.Maintenance)
      }, shutdownTime - rightJustNow - 1800000)

      return () => clearTimeout(timeout)
    }
    if (shutdownTime - rightJustNow > 0) {
      setOpenView(OpenView.Maintenance)
    }
  }, [systemInfo, serverTimeMargin])

  return (
    openView &&
    isFinishFetch && (
      <Container id="notificationbar" {...props}>
        {openView == OpenView.Maintenance && <MaintenanceNoti />}
      </Container>
    )
  )
}
const Container = styled(OpenEffect).attrs({ openType: 'slideTopToBottom' })`
  position: relative;
  background: ${({ theme }) => theme.colors.background};
  height: var(--notification-bar-height);
  width: 100%;
`

export default NotificationBar
